const styles = ({ variables }) => ({
  form: {
    marginBottom: '1em',
    composes: 'LoginForm',
  },
  row: {
    marginBottom: '0.5em',
  },
  actions: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  link: {
    textDecoration: 'none',
    color: variables.colors.greyFour,
    fontStyle: 'italic',
    '&:hover, &:active &:focus': {
      color: variables.colors.dark,
    },
  },
  needHelp: {
    paddingTop: 10,
    fontSize: 14,
  },
  '@global': {
    html: {
      height: '100%',
      padding: 0,
      margin: 0,
    },
    body: {
      backgroundColor: variables.colors.light,
      color: variables.colors.dark,
      height: '100%',
    },
    h1: {
      ...variables.type.h1,
    },
  },
  passwordRow: {
    '& input': {
      paddingRight: '2em',
      '&::-ms-clear, &::-ms-reveal': {
        display: 'none',
      },
      '&::-webkit-contacts-auto-fill-button': {
        visibility: 'hidden',
        display: 'none !important',
        pointerEvents: 'none',
        height: '0',
        width: '0',
        margin: '0',
      },
      '&::-webkit-credentials-auto-fill-button': {
        visibility: 'hidden',
        display: 'none !important',
        pointerEvents: 'none',
        height: '0',
        width: '0',
        margin: '0',
      },
    },
  },
  eye: {
    position: 'absolute',
    right: '3px',
    top: '3px',
    height: 'calc(100% - 6px)',
    border: 'none',
    background: 'transparent',
    '& .Icon': {
      width: '1em',
      height: '1em',
    },
    cursor: 'pointer',
    '&:hover, &:active &:focus': {
      cursor: 'pointer',
    },
  },
});

export default styles;
